export const PublicPathProviderTypeName = 'PublicPathProvider';
export class PublicPathProvider {
    constructor(options) {
        this.providingFunction = options === null || options === void 0 ? void 0 : options.provide;
    }
    getPublicPath() {
        if (!this.providingFunction) {
            return undefined;
        }
        return this.providingFunction();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHVibGljLXBhdGgucHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL3B1YmxpYy1wYXRoL3B1YmxpYy1wYXRoLnByb3ZpZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1BLE1BQU0sQ0FBQyxNQUFNLDBCQUEwQixHQUFHLG9CQUFvQixDQUFDO0FBRS9ELE1BQU0sT0FBTyxrQkFBa0I7SUFHM0IsWUFBbUIsT0FBa0M7UUFDakQsSUFBSSxDQUFDLGlCQUFpQixHQUFHLE9BQU8sYUFBUCxPQUFPLHVCQUFQLE9BQU8sQ0FBRSxPQUFPLENBQUM7SUFDOUMsQ0FBQztJQUVNLGFBQWE7UUFDaEIsSUFBSSxDQUFDLElBQUksQ0FBQyxpQkFBaUIsRUFBRTtZQUN6QixPQUFPLFNBQVMsQ0FBQztTQUNwQjtRQUNELE9BQU8sSUFBSSxDQUFDLGlCQUFpQixFQUFFLENBQUM7SUFDcEMsQ0FBQztDQUNKIn0=